/** @griffel:css-start [d] null **/
.f22iagw{display:flex;}
.f122n59{align-items:center;}
.f4d9j23{justify-content:center;}
.f1oa9isr{inline-size:32px;}
.f1da94u2{block-size:32px;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.ft85np5{border-radius:var(--borderRadiusMedium);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.fw3pusv{background-color:var(--bfAccentBackground);}
.f19n0e5{color:var(--colorNeutralForeground1);}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f1nqfz0o{padding-inline:6px;}
.f44lkw9{border-radius:var(--borderRadiusCircular);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f1ynw2h5{background-color:var(--bfStatusWarningBackground);}
.fhc94cr{color:var(--bfStatusWarningForeground);}
.fl43uef{font-weight:var(--fontWeightSemibold);}
.fz5stix{white-space:nowrap;}
/** @griffel:css-end **/